export default __webpack_public_path__ + "dist/img/JCB.png";